import { useDispatch, useSelector } from "react-redux";
import { formatDateYYYYMMDD } from "../../../utils";
import { checkItem } from "../../../modules/reducers/lostFound/checkListedItem";
import { useEffect } from "react";
import checkListedItemApi from "../api/checkListedItemApi";
import { useNavigate } from "react-router-dom";

const useCheckListedItem = () => {
  const dispatch = useDispatch();

  const tempUserId = useSelector((state) => state.checkArsStatus.userId);
  const channelId = useSelector((state) => state.checkArsStatus.channelId);
  const userId = tempUserId??"".replaceAll(" ", "+");
  const store_code = useSelector((state) => state.checkArsStatus.branchId);

  const list = useSelector((state) => state.checkListedItem.list);
  const navigate = useNavigate();

  useEffect(() => {
    const today = new Date();
    const currentDate = formatDateYYYYMMDD(today);
    const reg_start_date = currentDate;
    const reg_end_date = currentDate;

    const data = {
      store_code,
      reg_start_date,
      reg_end_date,
    };

    const api = checkListedItemApi({chnl_id: channelId});
    dispatch(checkItem({ ...api, data }));
  }, [userId]);

  const checkListedItem = () => {
    if (list !== null && Array.isArray(list) && list.length > 0) {
      navigate("/lost?exist=true");
    } else if (list === null || list.length === 0) {
      navigate("/lost?agree=true");
    }
  };
  return { checkListedItem, list };
};

export default useCheckListedItem;
